// businessFormConstants.js - Centralized configuration for Add Business Form

// Business quota constants
export const BUSINESS_QUOTAS = {
    free: 1,
    premium: 5
  };
  
  // Business type options
  export const BUSINESS_TYPES = [
    { value: 'physical', label: 'Physical Business Location' },
    { value: 'online', label: 'Online Business Only' },
  ];
  
  // Top categories for business selection
  export const TOP_CATEGORIES = [
    { id: 1, name: 'Restaurants' },
    { id: 2, name: 'Retail' },
    { id: 3, name: 'Healthcare' },
    { id: 4, name: 'Technology' },
    { id: 5, name: 'Automotive' },
    { id: 6, name: 'Legal' },
    { id: 8, name: 'Startup' },
    { id: 7, name: 'Other Professional Services' },
  ];

  // Description prompt per category. Revfer only writes about what the owner
  // names here, so the examples are concrete on purpose: they show the KIND of
  // detail that produces varied posts. Default = no category picked yet.
  export const DESCRIPTION_PROMPT_DEFAULT = {
    label: 'What do you sell or offer? Name 2–3 things',
    placeholder: 'e.g. Your top products or services, what makes you different, and who you serve',
  };

  export const DESCRIPTION_PROMPTS = {
    'Restaurants': {
      label: 'What do you serve?',
      placeholder: 'e.g. Hyderabadi dum biryani, Friday thali special, catering for 50+ guests, free delivery within 3 km',
    },
    'Retail': {
      label: 'What do you sell?',
      placeholder: 'e.g. Handmade silk sarees, bridal collection, custom blouse stitching in 3 days',
    },
    'Healthcare': {
      label: 'What do you treat or offer?',
      placeholder: 'e.g. Back and neck pain physiotherapy, sports injury rehab, home visits for seniors',
    },
    'Technology': {
      label: 'What services or products do you offer?',
      placeholder: 'e.g. Laptop and phone repair, CCTV installation, data recovery, annual maintenance contracts',
    },
    'Automotive': {
      label: 'What services do you offer?',
      placeholder: 'e.g. Car AC repair, full service in 4 hours, free pickup and drop',
    },
    'Legal': {
      label: 'What do you help clients with?',
      placeholder: 'e.g. Property registration, rental agreements, family and divorce cases',
    },
    'Startup': {
      label: "What does your product do, who is it for, and what's new?",
      placeholder: 'e.g. Scheduling app for clinics, WhatsApp reminders that reduce no-shows, just launched Hindi support, free 14-day trial',
    },
    'Other Professional Services': {
      label: 'What do you offer, and to whom?',
      placeholder: 'e.g. Emergency plumbing and leak repair · Website and app development · Tax filing and GST registration · Home tuition for classes 8–12',
    },
  };
  
  // Form step configuration
  export const FORM_STEPS = [
    'Basic Information',
    'Location & Hours',
    'Categories & Services (optional)',
    'Photos & Details (optional)',
  ];
  
  // Form tips by step - provides helpful guidance for each step
  export const FORM_TIPS = {
    0: [
      'Provide accurate business name',
      'Choose the most relevant category',
      'Include all contact information',
      'Add audio description for better engagement'
    ],
    1: [
      'Add complete address details',
      'Specify service areas if applicable',
      'Include business hours in additional info',
    ],
    2: [
      'Select all relevant categories',
      'List platforms where you can be found',
      'Add important business channels',
    ],
    3: [
      'Upload clear business photos',
      'Add detailed description',
      'Include relevant keywords',
    ],
  };
  
  // Configuration for form behavior
  export const FORM_CONFIG = {
    maxPlatforms: 4,
    maxKeywords: 10,
    maxKeywordLength: 20,
    acceptedImageTypes: 'image/*',
    maxImageSizeMB: 10, // For future validation if needed
  };
  
  // Default form data structure - useful for resetting form or initial state
  export const DEFAULT_FORM_DATA = {
    // Basic Information
    businessName: '',
    businessType: '',
    category: '',
    phone: '',
    email: '',
    website: '',
    description: '',
    userRole: '',
  
    // Location & Hours
    address: '',
    additionalInfo: '',
    googlePlaceId: '',
  
    // Categories
    additionalCategories: [],
  
    // Photos & Details
    photo: '',
    specialFeatures: '',
    keywords: [],
    audioDescription: null,
  
    // Platforms
    platforms: [],
  };